import {scrollTo} from "@/functions/scrollTo";

export default class Modal {
	constructor(defaultOptions) {
		this.defaultOptions = Object.assign({
			isDismisable: true,
			isDismisableViaBackgroundClick: true,
			isDismisableViaEscape: true,
			destroyed: null,
		}, defaultOptions);
		this.history = [];
		this.isOpen = false;
		this.callback = null;
		this.options = null;
	}

	#openState(options, callback = null) {
		this.options = Object.assign({}, this.defaultOptions, options);
		this.callback = callback;
		this.isOpen = true;
	}

	open(options, callback = null) {
		this.close(() => {
			this.#openState(options, callback);
		});
	}

	replace(options, callback = null) {
		let config = typeof callback === "function" ? {
			callback: callback,
		} : Object.assign({}, {
			withHistory: true,
		}, callback);

		if (!this.isOpen) {
			return this.open(options, config.callback);
		}

		if (config.withHistory) {
			this.history.push(this.options);
		}

		this.#openState(options, callback);
	}

	replaceOnly(options, callback = null) {
		this.replace(options, {
			callback: callback,
			withHistory: false,
		});
	}

	close(callback = null) {
		this.callback = callback;

		if (!this.isOpen) {
			return this.executeCallback();
		}

		this.isOpen = false;
		this.history = [];
	}

	back(callback = null) {
		if (!this.canGoBack()) {
			return this.close(callback);
		}

		this.replaceOnly(this.history.pop(), callback);
	}

	canGoBack() {
		return this.history.length > 0;
	}

	routeTo(route, keepOpen = false) {
		this.$router.push(route);

		if (!keepOpen) {
			return this.close();
		}
	}

	dismiss() {
		if (!this.options.isDismisable) {
			return;
		}

		this.close();
	}

	dismissViaBackgroundClick() {
		if (!this.options.isDismisableViaBackgroundClick) {
			return;
		}

		this.dismiss();
	}

	dismissViaEscape() {
		if (!this.options.isDismisableViaEscape) {
			return;
		}

		this.dismiss();
	}

	resetScroll() {
		scrollTo(0, {
			context: "[data-modal-scroll-region]",
		});
	}

	scrollTo(target) {
		let paddingElement = document.querySelector("[data-modal-padding]");
		let padding = paddingElement ? parseInt(window.getComputedStyle(paddingElement).getPropertyValue("padding-top").replace("px", "")) : 0;
		console.log("vmodal.scrollTo", {
			context: "[data-modal-scroll-region]",
			shift: -Math.abs(padding) + 16,
			whenAboveView: true,
		});
		scrollTo(target, {
			context: "[data-modal-scroll-region]",
			shift: -Math.abs(padding) + 16,
			whenAboveView: true,
		});
	}

	executeCallback() {
		this.callback?.call();
	}
}
